import attachmentsConfig from '../configs/attachmentTypes';

function getExtension(fileName: string): string {
  return fileName.split('.')[fileName.split('.').length - 1];
}

function isImg(fileName: string): boolean {
  return attachmentsConfig.imgExtensions.indexOf(getExtension(fileName)) !== -1;
}

function isDoc(fileName: string): boolean {
  return attachmentsConfig.docExtensions.indexOf(getExtension(fileName)) !== -1;
}

function getNameById(id: string): string | null {
  let attachmentTypeObject: {id: string; label: string} | undefined = attachmentsConfig.attachmentTypes.import.find((item: {id: string; label: string}) => {
    return id === item.id;
  });

  if(!attachmentTypeObject) {
    attachmentTypeObject = attachmentsConfig.attachmentTypes.export.find((item: {id: string; label: string}) => {
      return id === item.id;
    });
  }
  
  return attachmentTypeObject? attachmentTypeObject.label : null;
}

export {
  getExtension,
  isImg,
  isDoc,
  getNameById
}